/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Row/theme';

export const RowTheme = theme;
